module.exports = __webpack_public_path__ + "static/media/coffee-latte-dt-fr.6f59c87c.mp4";